<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Global HYCO Awards by Primary SOG competitor</h4>
    <div class="marginL30">
        <div class="row fullwidth">
            <div class="btndiv">
                <dx-button icon="export" text="Export Charts" type="default" [width]="160" (onClick)="exportCharts()">
                </dx-button>
            </div>
        </div>
        <div class="row fullwidth">
            <div class="col-md-7">
                <dx-chart palette="soft" [customizePoint]="customizePoint" class="width100" #pivchart id="pivchart"
                    [dataSource]="hycoAnalysisData" title="HyCO Analysis: SOG market by process and primary competitor">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="hycoCategory" valueField="totalHycoMMSCFD"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="Total Hyco (in MMSCFD)"></dxo-title>
                    </dxi-value-axis>
                    <dxo-legend verticalAlignment="top" [visible]="true" horizontalAlignment="center"
                        itemTextPosition="top"></dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="1">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-argument-axis [allowDecimals]="false">
                    </dxo-argument-axis>
                    <dxo-series-template nameField="hyCOSOGCompetitor"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </div>
            <div class="col-md-5">
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" id="pie"
                    title="HyCO Analysis: SOG market by primary competitor" palette="soft"
                    [dataSource]="sogMarketByPrimaryCompetitorData">
                    <dxi-series argumentField="hyCOSOGCompetitor" valueField="totalHyCOMMSCFD">
                        <dxo-label [customizeText]="customizeLabelPieChart1" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-legend [visible]="false">
                    </dxo-legend>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </div>
        </div>
        <hr />
        <div class="row fullwidth">
            <dx-data-grid class="fixGridHeight" id="globalHycoAwardsReportGrid"
                (onOptionChanged)="onGlobalHycoAwardsReportGridOptionChanged($event)"
                [dataSource]="globalHycoAwardsReportData" [showRowLines]="true" [showColumnLines]="true"
                [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true">
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-sorting mode="multiple"></dxo-sorting>
                <dxo-search-panel [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="false"></dxo-export>
                <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                <dxo-toolbar>
                    <dxi-item name="groupPanel"></dxi-item>
                    <dxi-item location="after">
                        <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                        </dx-button>
                        <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                            (onClick)="exportExcel($event)">
                        </dx-button>
                    </dxi-item>
                    <dxi-item name="searchPanel"></dxi-item>
                </dxo-toolbar>
                <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                    [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

                <dxi-column dataField="worldRegion" [width]="120"></dxi-column>
                <dxi-column dataField="siteId" [visible]="false" caption="Site Id" [width]="120"></dxi-column>
                <dxi-column dataField="productionFacilityId" caption="Facility ID " [width]="120"></dxi-column>
                <dxi-column dataField="countryName" caption="Country" [width]="100"></dxi-column>
                <dxi-column caption="State/Province" dataField="province" [width]="100"></dxi-column>
                <dxi-column dataField="city" [width]="100"></dxi-column>
                <dxi-column dataField="hyCOSOGCompetitor" caption="HyCO SOG Competitor" [width]="150"></dxi-column>
                <dxi-column dataField="hycoCategory" [width]="150"></dxi-column>
                <dxi-column dataField="feedstockName" caption="Feedstock" [width]="150"></dxi-column>
                <dxi-column dataField="technologyProvider" [width]="150"></dxi-column>
                <dxi-column dataField="customer" [width]="150"></dxi-column>
                <dxi-column dataField="status" [width]="100"></dxi-column>
                <dxi-column dataField="onstreamYear" width="100"></dxi-column>
                <dxi-column dataField="awardYear" caption="Award Year" width="100"></dxi-column>
                <dxi-column dataField="shutdownYear" width="100"></dxi-column>
                <dxi-column dataField="hydrogen" caption="Hydrogen (kNm3/h)" width="100"></dxi-column>
                <dxi-column dataField="hydrogenMMSCFD" width="120" caption="Hydrogen (MMSCFD)"></dxi-column>
                <dxi-column dataField="carbonMonoxide" caption="Carbon Monoxide (kNm3/h)" width="100"></dxi-column>
                <dxi-column dataField="carbonMonoxideMMSCFD" width="120"
                    caption="Carbon Monoxide (MMSCFD)"></dxi-column>
                <dxi-column dataField="syngas" caption="Syngas (kNm3/h)" width="100"></dxi-column>
                <dxi-column dataField="syngasMMSCFD" width="120" caption="Syngas (MMSCFD)"></dxi-column>
                <dxi-column dataField="totalHyco" caption="Total HyCO (kNm3/h)" width="100"></dxi-column>
                <dxi-column dataField="totalHycoMMSCFD" width="120" caption="Total HyCO (MMSCFD)"></dxi-column>
                <dxi-column dataField="endUseApplication" [width]="170"></dxi-column>
                <dxi-column dataField="notes" caption="Notes" [width]="500"></dxi-column>
            </dx-data-grid>
        </div>

        <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
            [shading]="false" [closeOnOutsideClick]="false">
        </dx-load-panel>
    </div>
</div>